import createSagaMiddleware from 'redux-saga';

const reduxSagaMonitorOptions = {
  onError: (error: Error) => {
    setTimeout(() => {
      throw error; // we can't recover zombie saga, so need to re-throw and crash
    }, 0);
  },
};
export const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

export default sagaMiddleware;
